import React from "react";
import { useFormContext } from "react-hook-form";
import { Text } from "$components";
import CField from "$forms/CField";
import FileUploader from "$components/FileUploader/FileUploader";
import useAuth from "$hooks/useAuth";
import useJStyles from "$hooks/useJStyles";

export const EntrepotFormAttachments: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { isAdmin } = useAuth();
  const { jclasses } = useJStyles();

  return (
    <>
      <div className={jclasses.formSectionHead}>
        <Text type="h3"> Pièces jointes </Text>
      </div>
      <CField
        control={control}
        disabled={!isAdmin()}
        name="medias"
        error={errors.medias}
      >
        {(props) => (
          <FileUploader
            company={undefined}
            type="dockyard"
            {...props}
            isAdmin={isAdmin()}
          />
        )}
      </CField>
    </>
  );
};
